var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-layout',{attrs:{"models-loaded":true,"name":"Users","imgPosY":"-300"}},[_c('h1',[_vm._v("Utilisateurs")]),_vm._v(" "),_c('model-manager',{attrs:{"model-to-manage":_vm.modelToManage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27192065","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/User/index.vue
// module id = NaQW
// module chunks = 1